module.exports = "/images/neighborhood.svg";